const ionic = require('ionic')
const { config: globalConfig } = require('js/global/module')

module.exports = ['$scope', '$rootScope', '$state', '$phoneModal', 'User', '$translate', '$utils', '$ionicPopup',
  '$timeout', 'mailFolderService', 'composeService', '$cookies', 'Promise', 'LocalStorage', 'secondAuthService', '$interval',
  function ($scope, $rootScope, $state, $phoneModal, User, $translate, $utils,
    $ionicPopup, $timeout, mailFolderService, composeService, $cookies, Promise, LocalStorage, secondAuthService, $interval) {
    if ($state.current.name === 'frame.setting') {
      init()
    }
    if ($state.current.name === 'frame.languageSetup') {
      $scope.languageList = globalConfig.languageList
      const language = $cookies.get('NG_TRANSLATE_LANG_KEY')
      $scope.currentLanguage = language
      $rootScope.languageName = languageType(language)
    }
    function init() {
      $scope.deviceInformation = ionic.Platform
      $scope.settingMenu = $rootScope.settings['settingMenu']
      $rootScope.languageName = languageType($cookies.get('NG_TRANSLATE_LANG_KEY'))
      initUser()
    }
    // 根据语言代号获取语言名称
    function languageType(language) {
      const languageList = globalConfig.languageList
      for (let i = 0; i < languageList.length; i++) {
        if (languageList[i].code === language) {
          return languageList[i].name
        }
      }
    }
    // 点击选择语言
    $scope.useLanguage = function (language) {
      // 改变用户的语言配置，使得接口返回对应语言的响应数据
      Promise.wmCall('user:changeFaceSettings', { locale: language }
      ).then(res => {
        if (res.var.changed) $scope.$emit('refreshGroups')
      })
      $scope.currentLanguage = language
      $rootScope.languageName = languageType(language)
      $translate.use(language)
    }
    $scope.closeModal = function (modalId) {
      if ($scope.modal && $scope.modal[modalId]) {
        $scope.modal[modalId].remove()
      }
    }

    $scope.changeDav = function () {
      $scope.user.save()
    }

    $scope.openModalById = function (modalId) {
      switch (modalId) {
        case 'signature': // 签名档设置Modal
          LA.track('A5C1')
          _openModal(modalId, require('views/setting/signature/signature.html'))
          break
        case 'appInfo': // 关于app信息Modal
          LA.track('A5C6')
          getAppInformation()
          _openModal(modalId, require('views/setting/about.html'))
          break
      }
    }

    function _openModal(id, template) {
      $scope.modal = $scope.modal || {}
      $scope.modal[id] = $phoneModal.fromTemplate(template, {
        id: id,
        /** 创建新的 scope 以防止暴露自身 */
        /** create a new scope to prevent exposing current modal itself */
        scope: $scope.$new(),
        animation: 'slide-in-right'
      })
      $utils.$modalFunc.prepareModalBack($scope.modal[id])
      $scope.modal[id].show()
    }

    function initUser() {
      $scope.user = User.getCurrentUser()
    }
    // 修改密码，先判断是否需要进行二次验证，需要的话弹出二次验证模态框，不需要的话进入修改密码页
    $scope.handleChangePassword = function () {
      secondAuthService.querySecondAuth().then(function (data) {
        if (data.code === 'S_OK') {
          switch (data.var.type) {
            case 'DISABLED': // 无需二次验证
              $state.go('frame.changePassword')
              break
            case 'SMS': // 短信验证码
              OpenSecondAuthModal('SMS', data.var)
              break
            case 'DYNAMIC': // 动态口令验证
              OpenSecondAuthModal('DYNAMIC')
              break
            case 'OTP': // APP授权
              OpenSecondAuthModal('OTP')
              break
          }
        }
      }, function (error) {
        console.log(error)
      })
    }
    // 打开二次验证模态框并触发二次验证
    function OpenSecondAuthModal(type, querySecondAuthResultData) {
      $scope.secondAuthType = type
      $scope.secondAuthModal = $phoneModal.fromTemplate(require('views/setting/secondAuthModal.html'), {
        id: 'authByAPP',
        scope: $scope,
        animation: 'slide-in-up'
      })
      $scope.inputSecAuthCode = false
      $scope.secondAuthModal.show()
      secondAuthService.triggerSecondAuth(false, { trans: 'change_password' }).then(function (data) {
        if (data.code === 'S_OK') {
          $scope.secondAuthTempSid = data.var.tempSid
          pollingforAuth()
          if (type === 'SMS') {
            $scope.last4Number = querySecondAuthResultData.cellNumber.slice(-4)
            $scope.remainingSeconds = 60
            $scope.isSendCodeDisabled = true
            sendCodeCountDown()
          }
        }
      }, function (error) {
        console.log(error)
      })
    }
    // 重新发送短信验证码
    $scope.resendCellphoneVerifyCode = function() {
      secondAuthService.triggerSecondAuth(false, { trans: 'change_password' }).then(function (data) {
        if (data.code === 'S_OK') {
          $scope.secondAuthTempSid = data.var.tempSid
          if ($scope.cellNumber) {
            $scope.last4Number = $scope.cellNumber.slice(-4)
            $scope.cellNumber && $scope.$emit('VERIFICATION.SET_SEND_CODE_CACHE', {cellNumber: {number: $scope.last4Number}})
          }
          $scope.remainingSeconds = 60
          $scope.isSendCodeDisabled = true
          $utils.$notify.set({message: $translate.instant('VERIFICATION.MSG_HAS_SENT_PHONE')})
          sendCodeCountDown()
        }
      }, function (error) {
        console.log(error)
      })
    }
    // 切换APP授权方式，直接授权或者验证码授权
    $scope.switchAuthMethod = function () {
      $scope.secondAuthByCode = !$scope.secondAuthByCode
    }
    // 轮询监听二次验证结果,验证成功进入修改密码页
    function pollingforAuth() {
      $scope.timer = $interval(function () {
        secondAuthService.querySecondAuthValidateStage(false, $scope.secondAuthTempSid, 'change_password').then(function (data) {
          if (data.code === 'S_OK' && data.var.stage == 'VALIDATED') {
            $interval.cancel($scope.timer)
            $state.go('frame.changePassword', {secondAuthTempSid: $scope.secondAuthTempSid})
          }
        }, function (error) {
          console.log(error)
        })
      }, 1000)
    }
    // 60s倒计时
    function sendCodeCountDown() {
      $scope.remainingSeconds--
      if ($scope.remainingSeconds <= 0) {
        $scope.isSendCodeDisabled = false
      } else {
        $scope.sendCodeCountDownPromise = $timeout(sendCodeCountDown, 1000)
      }
    }
    // 关闭二次验证模态框, 要同时把监听验证结果的timer取消
    $scope.closeSecondAuthModal = function () {
      $interval.cancel($scope.timer)
      $scope.secondAuthModal.remove()
    }
    $scope.secondAuth = {
      secondAuthCode: ''
    }
    // 二次验证确认
    $scope.confirmSecondAuthCode = function (type) {
      const options = {
        tempSid: $scope.secondAuthTempSid,
        verifyCode: $scope.secondAuth.secondAuthCode,
        trans: 'change_password'
      }
      secondAuthService.validateSecondAuth(options).then(function (data) {
        if (data.code === 'S_OK') {
          $state.go('frame.changePassword', {secondAuthTempSid: $scope.secondAuthTempSid})
        }
      }, function (error) {
        if (error.data.code === 'FA_INVALID_VERIFY_CELL') {
          $utils.$notify.set({message: $translate.instant('VERIFICATION.WRONG_CODE')})
        } else if (error.data.code === 'FA_INVALID_DYNAMIC_PWD') {
          if (type === 'OTP') {
            $utils.$notify.set({message: $translate.instant('VERIFICATION.WRONG_CODE')})
          } else if (type === 'DYNAMIC') {
            $utils.$notify.set({message: $translate.instant('LOGIN.FA_INVALID_DYNAMIC_PWD')})
          }
        }
      })
    }
    // 进入语言切换页
    $scope.handleLanguageSetup = function () {
      LA.track('A5C2')
      $state.go('frame.languageSetup')
    }
    // 打开共享邮箱设置页
    $scope.handleSharedMailboxSetup = function () {
      $state.go('frame.sharedMailbox')
    }

    $scope.logout = function () {
      function doLogout() {
        composeService.clearAccountCache()
        mailFolderService.clearFolders()
        LocalStorage.removeItem('hideBulkSingleTipInCurrentSession')
        $scope.user.logout().then(function () {
          $state.go('login')
        }, function () {
          $state.go('login')
        })
      }
      const confirmPopup = $ionicPopup.confirm({
        template: $translate.instant('SETTING.CONFIRM_TO_LOGOUT'),
        cancelText: $translate.instant('OP.CANCEL'),
        cancelType: 'button-positive',
        okText: $translate.instant('OP.LOGOUT'),
        okType: 'button-default'
      })

      confirmPopup.then(function (res) {
        if (res) {
          LA.track('A5C3')
          doLogout()
        }
      })
    }
    $scope.showLogout = function() {
      const logout = $scope.settingMenu.logout
      return logout === 'auto' ? !$utils.$misc.MD.isAppEmbed : !!logout
    }

    $scope.handleSecAuth = function () {
      $scope.user = User.getCurrentUser()
      const email = $scope.user.config.email
      $state.go('frame.auth', { email: email, type: 'accountList', params: '' })
    }

    // 获取app信息
    function getAppInformation() {
      $scope.coremailAppVersion = 'v' + VERSION + ' build ' + COMMITHASH //eslint-disable-line
    }
  }]



// WEBPACK FOOTER //
// ./src/js/setting/settingCtrl.js